module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAABZ0lEQVRIx2NgMF1LNrqjIk82YsA0Ti+wL7c8uaE5LCC1nNViFR6LP8yfSzZCt7ilLfjlYf6onAIB+0Vsliv1A/tUvKdKu85mMV8F5KIp/nX3DtkIxeLEwuyfZ1mAPoZwgZaJOc2Ly8vNLEmLzs3ntV3CbbOMJkF9bYfMvKlOcC6X9TKX+PoDq7TfHOU9s0k5qTCb2Ww1svqvBw+QjRAWA6PzzwWmjJI0uAgwhNvag4Bh8P8iw78LjBP7vLX9J1DfYiB6dYSvqTUUzlXxmZpXkfThBBfQ4u9nWIFSurBYoHJQL5zhcH2HNLvVCngYeCVXl9fFzJnq0toWDGSjxTHVEpew44KH+0QWzbBHtsAjsdoivB3oe8ysRc3sBMxFUyd4HFmrMX2ie255inFoF1CQyXwNPQoQ4tF/CgDDrthCstHr5kayEcNDV8cBQQz/BwgwPEuMHRA0cBYPWFAPWOKiJEtQlJ0GKqgBOQiHEe+Y9eYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/my.png
// module id = 888
// module chunks = 0